export const rightBorderPlugin = {
  id: "rightBorder",
  afterDraw(chart) {
    const { ctx, chartArea } = chart;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(chartArea.right, chartArea.top);
    ctx.lineTo(chartArea.right, chartArea.bottom);
    ctx.strokeStyle = "#ccc";
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();
  },
};




